import React from 'react';
import CheckCalendarContainer from '../../organisms/RTCC/checkCalendarContainer';
import CheckListPopupContainer from "../../organisms/RTCC/checkListPopupContainer";
import HeaderContainer from '../../organisms/RTCC/headerContainer';
import ReservationPopupContainer from "../../organisms/RTCC/reservationPopupContainer";
import RtccReservationResultContainer from '../../organisms/RTCC/rtccReservationResultContainer';
import ScrollToTop from '../../atoms/RTCC/scrollToTop';

class rtccReservationResultTemplate extends React.Component {

    render() {
        return (
            <>
                <ScrollToTop />
                <HeaderContainer
                    Label categoryLabel1={"検索結果"}
                    categoryLabel2={"RESULT"}
                    path={"/reserve/rtcc/reservation"}
                    bookedConfirmLabel={"＞予約内容の確認・変更・キャンセルはこちら"}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
                    tabIndex="19" />
                <ReservationPopupContainer
                    state={this.props.state}
                    setPopupMode={this.props.setPopupMode}
                    setPopupMessage={this.props.setPopupMessage}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                    onClickCountWindow={this.props.onClickCountWindow}
                    createAgeCountList={this.props.createAgeCountList} />
                <CheckListPopupContainer
                    state={this.props.state}
                    onClickOpenCheckListWindow={this.props.onClickOpenCheckListWindow} />
                <CheckCalendarContainer
                    state={this.props.state}
                    onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
                    checkInFlg={this.props.state.checkInFlg}
                    checkOutFlg={this.props.state.checkOutFlg} />
                <RtccReservationResultContainer
                    state={this.props.state}
                    onClickOpenCheckListWindow={this.props.onClickOpenCheckListWindow}
                    onClickOpenCalendarWindow={this.props.onClickOpenCalendarWindow}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
                    setPopupData={this.props.setPopupData}
                    setPopupMessage={this.props.setPopupMessage}
                    setBeforeAreaId={this.props.setBeforeAreaId}
                    setBeforeCountryId={this.props.setBeforeCountryId}
                    createAgeCountList={this.props.createAgeCountList}
                />

            </>
        )
    }
}
export default rtccReservationResultTemplate;